<template>
    <BreadCrumb PageTitle="Liste des membres" />
    <ListeAssign/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeAssign from "@/components/Assignations/listeAssign.vue";
  
    export default defineComponent({
      name: "AddAssignPage",
      components: {
        BreadCrumb,
        ListeAssign,
      },
    });
  </script>